import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import RecordVideoDetails from './RecordVideoDetails';
import RecordVideoNoEmailSuccess from './RecordVideoNoEmailSuccess';
import RecordVideoSuccessToEmail from './RecordVideoSuccessToEmail';
import StandardFrontCard from '../SingleAction/SingleActionDetails';

import EmailDetails from '../Email/EmailDetails';
import EmailDetailsMultiRepStep2 from '../Email/EmailDetailsMultiRepStep2';
import EmailSuccess from './RecordVideoEmailSuccess';
import FindLocalRep from '../LocalRep/FindLocalRep';

const RecordVideoStart = StandardFrontCard('recordvideo');
const EmailDetailsCard = EmailDetails('recordvideo','/recordvideo/email');
const EmailDetailsMultiRepStep2Card = EmailDetailsMultiRepStep2('email','/recordvideo/multiRepStep2');

const RecordVideo = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.pathname} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/recordvideo/start"
                            name="RecordVideoStart"
                            exact
                            component={RecordVideoStart}
                        />
                        <Route
                            path="/recordvideo"
                            name="RecordVideoDetails"
                            exact
                            component={RecordVideoDetails}
                        />
                        <Route
                            path="/recordvideo/noemailsuccess"
                            name="RecordVideoNoEmailSuccess"
                            exact
                            component={RecordVideoNoEmailSuccess}
                        />
                        <Route
                            path="/recordvideo/successtoemail"
                            name="RecordVideoSuccessToEmail"
                            exact
                            component={RecordVideoSuccessToEmail}
                        />
                        <Route
                            path="/recordvideo/email"
                            name="EmailDetails"
                            exact
                            component={EmailDetailsCard}
                        />
                        <Route
                            path="/recordvideo/multiRepStep2"
                            name="EmailDetailsMultiRepStep2"
                            exact
                            component={EmailDetailsMultiRepStep2Card}
                        />
                        <Route
                            path="/recordvideo/emailsuccess"
                            name="EmailSuccess"
                            exact
                            component={EmailSuccess}
                        />
                        <Route
                            path="/recordvideo/findRep"
                            name="RecordVideoFindRep"
                            exact
                            component={FindLocalRep}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default RecordVideo;
